import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './Item.html?raw';
// NOTE (JS2TS): dropped dead dojo deps (dom-construct, dom-attr, dom-class, dom-style) — not used.
// xstyle/css!./Item.css was already commented out in the original define().

class Item extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    entityID: any = null;
    jsonData: any = null;
    listContainer: any = null;

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;
    }

    startup(bReload?: any): void {
        if (this.jsonData == null || bReload === true) {
            this.loadOccurrence();
        }

        else {
            this.drawItem();
        }
    }

    loadOccurrence(entityID?: any): void {

        this.StandbyStart();

        var url = window.appRoot + "Occurrence/LoadOccurrencJSON";

        if (entityID != null && typeof (entityID) != "undefined") {
            this.entityID = entityID;
        }

        var occurrenceID = this.entityID;

        this.RequestManager.post(
            url,
            {
                occurrenceID: occurrenceID, // jsonData falls mal nötig
            },
            lang.hitch(this, "_onLoadOccurrenceResponse"),
            lang.hitch(this, "_onLoadOccurrenceError"),
            false // sync
        );
    }

    _onLoadOccurrenceResponse(response: any): void {
        this.StandbyStop();
        this.jsonData = JSON.parse(response);

        this.drawItem();
    }

    _onLoadOccurrenceError(error: any): void {
        this.StandbyStop();
    }

    drawItem(): void {
        if (this.jsonData == null) {
            return;
        }
    }

}
Item.prototype.declaredClass = 'WidgetCollection.Occurrence.List.Item';

export default mdsWidget(Item);
